import { Note, Spinner } from "@goodfill/ui-components";

export const DoNotCloseLoadingNote = () => (
  <Note intent="danger" className="flex flex-row items-center gap-2">
    <Spinner />
    Do not close the page until all orders are finished!
  </Note>
);
